import { Injectable } from '@angular/core';
import { IAppInfo, EPageType } from '../../interfaces/iapp-info.interface';

declare let appInfo: IAppInfo;

@Injectable()
export class AppInfoService {
    constructor() {
        try {
            this._appInfo = appInfo;
        } catch (ex) {
            // in test context we do not have access to the global variable appInfo,
            // so we provide a fallback that will be overwritten by the test
            this._appInfo = {} as IAppInfo;
        }
    }

    private _appInfo: IAppInfo;

    public get AppInfo() {
        return this._appInfo;
    }

    public set AppInfo(newAppInfo: IAppInfo) {
        this._appInfo = newAppInfo;
    }

    public isCountrySelectionPage(): boolean {
        return this.AppInfo.page.type === EPageType.CountrySelectionPage;
    }

    public isLandingPageLight(): boolean {
        return this.AppInfo.page.type === EPageType.LandingPageLight;
    }

    public isSearchResultPage(): boolean {
        return this.AppInfo.page.type === EPageType.SearchResultPage;
    }

    public isContactPage(): boolean {
        return this.AppInfo.page.type === EPageType.ContactPage;
    }

    public isContactDetailPage(): boolean {
        return this.AppInfo.page.type === EPageType.ContactDetailPage;
    }

    public isProductPage(): boolean {
        return this.AppInfo.page.type === EPageType.ProductPage;
    }

    public isProductSelectionPage(): boolean {
        return this.AppInfo.page.type === EPageType.ProductSelectionPage;
    }

    public isSitemap(): boolean {
        return this.AppInfo.page.type === EPageType.Sitemap;
    }

    public isAccountSettingsPage(): boolean {
        return this.AppInfo.page.type === EPageType.AccountSettingsPage;
    }

    public isHazmatPage(): boolean {
        return this.AppInfo.page.type === EPageType.HazmatPage;
    }

    public isHomePage(): boolean {
        return this.AppInfo.page.type === EPageType.HomePage;
    }

    public isProductComparePage(): boolean {
        return this.AppInfo.page.type === EPageType.ProductComparePage;
    }

    public isDwBreathAhead(): boolean {
        return this.AppInfo.page.type === EPageType.DwBreathAhead;
    }

    public isDwVoiceHazmat(): boolean {
        return this.AppInfo.page.type === EPageType.DwVoiceHazmatPage;
    }
    public isDwVoiceSearch(): boolean {
        return this.AppInfo.page.type === EPageType.DwVoiceSearchPage;
    }
}
